<template>
  <v-dialog v-model="showPreview" fullscreen>
    <v-card class="preview-content">
      <v-toolbar>
        <v-btn icon @click="showPreview = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title v-if="questionnaire">
          {{ $t('questionnairePreview.title') }}: {{ questionnaire.name }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <Questionnaire v-if="value" preview :questionnaire="questionnaire" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Questionnaire from '../../Questionnaire';

export default {
  name: 'QuestionnairePreview',
  components: {
    Questionnaire,
  },
  props: {
    value: {
      type: Boolean,
    },
    questionnaire: {
      type: Object,
      default: null,
    },
  },
  watch: {
    value(val) {
      this.showPreview = val;
    },
    showPreview(newVal) {
      this.$emit('input', newVal);
    },
  },
  data() {
    return {
      showPreview: false,
    };
  },
};
</script>

<style scoped>
.preview-content {
  background-color: #f5f6fa;
}
</style>
